import App from './App.svelte';
import Control from './routes/controls.svelte'
import Full from './routes/full.svelte'
import Uncut from './routes/uncut.svelte'

let app;

if (window.location.pathname === '/controls') {
	app = new Control({
		target: document.body,
	});
} else if (location.pathname.startsWith('/full/')) {
	const id = location.pathname.replace('/full/', '')
	app = new Full({
		target: document.body,
		props: {id}
	})
} else if (location.pathname === '/uncut') {
	app = new Uncut({
		target: document.body,
	})
} else {
	app = new App({
		target: document.body,
	});
}

export default app;
